/**
 * The React key of the connection editor (#1647). Each record gets its own editor so nothing of
 * the last connection (validation, counts, stale warning) follows the person to another one. The
 * one exception is a save on `/new`: the editor that saved is seeded from the answer and holds the
 * post-save guidance (the highlighted fields, "Your changes are saved either way"), so the new
 * connection's address keeps that same editor. The next visit to `/new` gets a fresh key.
 */
let newVisit = 0;
const keptFromNew = new Map<string, string>();

export function newEditorKey(): string {
  return `new-${newVisit}`;
}

/** Called when a create succeeds, before the address moves to the new connection. */
export function keepEditorForCreated(id: string): void {
  keptFromNew.set(id, newEditorKey());
  newVisit += 1;
}

export function editorKeyFor(id: string): string {
  return keptFromNew.get(id) ?? id;
}
